// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[dir] code[data-v-a857daaa] {\n  background-color: #f8f9fa;\n  padding: 2px 4px;\n  border-radius: 3px;\n}\n[dir] .badge[data-v-a857daaa] {\n  margin-bottom: 0.25rem;\n}\n[dir=ltr] .badge[data-v-a857daaa] {\n  margin-right: 0.25rem;\n}\n[dir=rtl] .badge[data-v-a857daaa] {\n  margin-left: 0.25rem;\n}\n", ""]);
// Exports
module.exports = exports;
